import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const Help = () => {
  const { t } = useLang();
  const faqs = [
    { q: "Where do you deliver?", a: "We currently focus on Caleta de Fuste and surrounding delivery areas." },
    { q: "Can I order for later?", a: "Yes. Select your preferred delivery time at checkout." },
    { q: "Can I order without creating an account?", a: "Yes. Guest checkout is always available — no account needed." },
    { q: "Can I order to my hotel?", a: "Yes. Enter your hotel name and room number during checkout." },
    { q: "What happens if I have a problem with my order?", a: "Contact customer support through the website — we're here to help." },
    { q: "How does payment work?", a: "This is a demo build; payment is simulated. In production, you can pay by card, Apple Pay or Google Pay." },
  ];
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-navy tracking-tight">{t("helpTitle")}</h1>
      <Accordion type="single" collapsible className="mt-8">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`}>
            <AccordionTrigger className="text-left font-heading text-navy">{f.q}</AccordionTrigger>
            <AccordionContent className="text-navy/70">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default Help;
